var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagePostedPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_202_64",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.600098,
    y: 0.416504,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_202_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6001 22.4165V4.4165C2.6001 3.8665 2.7961 3.3955 3.1881 3.0035C3.57943 2.61217 4.0501 2.4165 4.6001 2.4165H20.6001C21.1501 2.4165 21.6211 2.61217 22.0131 3.0035C22.4044 3.3955 22.6001 3.8665 22.6001 4.4165V16.4165C22.6001 16.9665 22.4044 17.4375 22.0131 17.8295C21.6211 18.2208 21.1501 18.4165 20.6001 18.4165H6.6001L2.6001 22.4165ZM4.6001 17.5915L5.7751 16.4165H20.6001V4.4165H4.6001V17.5915Z",
    fill: "#763FF9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagePostedPurple);
export default __webpack_public_path__ + "static/media/message_posted_purple.0b10c817aad41388c1245192bf6e27f9.svg";
export { ForwardRef as ReactComponent };